<template>
    <div>
     <div v-if="debug_show_page_name==true" style="color:green;">first_time_change_password</div> 
        <app-header no_back="true" settings="systemZoom" no_menu="true">esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot :title="pageTitle" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A -->
              <field-box :data="currentPassword"  :read="localReadOnly" :val="values['currentPassword']"></field-box>
              <field-box :data="newPassword"      :read="localReadOnly" :val="values['newPassword']"></field-box>
              <field-box :data="confirmPassword"  :read="localReadOnly" :val="values['confirmPassword']"></field-box>
            </div>
            <div class="col-xs-8" style="">
            </div>
          </div>
          <div class="col-xs-4" style="">
          <div class="row" style="margin-bottom:10px;">
              <button class="btn btn-primary"
              style="min-width:100px;float: right;margin-right: -10px;margin-right:10px;background: #92D050;border-color:#92D050;" 
              @click="processChangePassword"
              >実行</button>
            </div>
          </div>
      </div>
      <confirmation-modal tag="passwordChanged" @done="onPasswordChanged" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_master_change_password';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_belong_details');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"master_user",
      page_acl: acl.master_user_password,
      local_read_only:false
    };
  },
  computed: {
    pageTitle(){
      if(this.$route.meta.password_expired == true){
        return "パスワード変更(パスワード有効期限切れ)";
      }else{
        return "パスワードの変更 (初回ログイン)";
      }
    },
    localReadOnly:{
      get(){
        return this.local_read_only;
      },
      set(v){
        this.local_read_only = v;
      }
    },
    currentPassword(){
      return utils.extend(fields.current_password, {});
    },
    newPassword(){
      return utils.extend(fields.new_password, {});
    },
    confirmPassword(){
      return utils.extend(fields.confirm_password, {});
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
      }
    }
  },
  methods: {
    onPasswordChanged(){
      this.$router.push("/company");
    },
    local_show_error(text,title="Error",duration=10000){
      this.$notify({clean: true});
      this.$notify({
        title,
        text,
        type: 'error',
        duration
      });
    },
    processChangePassword(){
      var current_password =this.$store.state[this.stateCurrentEditing]["current_password"];
      var new_password  = this.$store.state[this.stateCurrentEditing]["new_password"];
      var confirm_password  =this.$store.state[this.stateCurrentEditing]["confirm_password"];
      if(new_password != confirm_password){
        return this.local_show_error("新しいパスワードと新しいパスワード(確認)は同じ必要があります。")
      }
      if(new_password == current_password){
        return this.local_show_error("新しいパスワードと現在のパスワードは違う必要があります。")
      }
      if(new_password == ""){
        return this.local_show_error("新しいパスワードが空白です。")
      }
      if(current_password == ""){
        return this.local_show_error("現在のパスワードが空白です。")
      }
      var ops = {
        current_password,
        new_password,
        confirm_password
      }
      this.$ajax.post('/' + this.api_name + '/change_password_first_time/', ops, (err, result) => {
        if(result.success == true && err == null){
          this.$notify({
            title:"パスワードが変更されました。",
            type: 'success',
            duration:5000
          });
          bus.$emit("passwordChanged",{
            message: "パスワードが変更されました。",
            title: "",
            yes_label: "完了",
            no_label: "",
            yes_color:"primary",
            no_color:"",
            model_height:"50"
          });
          this.clearFields();
        }else{
          return this.local_show_error(err||"Operation failed")
        }
      })
    },
    clearFields(){

      var form_fields = ["current_password","new_password","confirm_password"]
      form_fields.forEach((f)=>{
        this.$store.state[this.stateCurrentEditing] = {}
        this.$store.state[this.stateCurrentEditing][f] = "*"
        this.$store.state[this.stateCurrentRow][f] = "";
        this.$store.state[this.stateCurrentEditing][f] = ""
      })
      this.localReadOnly = true;
      setTimeout(() => {
        this.localReadOnly = false
      }, 100);
    },

    backToList(){
      return this.$router.push({ name: "menu_master", params: {} });
    }
  },
  mounted() {
    this.clearFields();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.clearFields();
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// first_time_change_password.vue?814c4b1e